module.exports = __webpack_public_path__ + "img/over65.52a9ad9f.png";